import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { CKEditorModule } from 'ng2-ckeditor';

// app
import { AppComponent } from './app.component';
import { AppRoutesModule } from './app.routes.module';

// guards
import { AuthGuard } from '../guards/auth.guard';

// pages
import { LoginPage } from '../pages/login/login';
import { DashBoardPage } from '../pages/dashboard/dashboard';

//members
import { MembersSearchPage } from '../pages/members/search/search';
import { MembersPendingPage } from '../pages/members/pending/pending';

import { MembersDetailPage } from '../pages/members/detail/detail';
import { MembersDetailBasicInformation } from '../pages/members/detail/basic/basic';
import { MembersDetailMembershipInformation } from '../pages/members/detail/membership/membership';
import { MembersDetailDemographicInformation } from '../pages/members/detail/demographic/demographic';
import { MemberDetailTabView } from '../pages/members/detail/tab-view/tab-view';

import { MembersReportPage } from '../pages/members/report/report';
import { MembersBatchUploadPage } from '../pages/members/batchupload/batchupload';
import { MembersSendpwdPage } from '../pages/members/sendpwd/sendpwd';

//schools
import { SchoolsSearchPage } from '../pages/schools/search/search';
import { SchoolsReportPage } from '../pages/schools/report/report';

import { SchoolsDetailPage } from '../pages/schools/detail/detail';
import { SchoolsDetailBasicInformation } from '../pages/schools/detail/basic/basic';
import { SchoolsDetailTabView } from '../pages/schools/detail/tab-view/tab-view';


//Teachers
import { TeachersSearchPage } from '../pages/teachers/search/search';
import { TeachersReportPage } from '../pages/teachers/report/report';

import { TeachersDetailPage } from '../pages/teachers/detail/detail';
import { TeachersDetailBasicInformation } from '../pages/teachers/detail/basic/basic';

//email templates

import { EmailTplsListPage } from '../pages/configs/email-tpls/list/list';
import { EmailTplsDetailPage } from '../pages/configs/email-tpls/detail/detail';
import { EmailTplsDetailBasicInformation } from '../pages/configs/email-tpls/detail/basic/basic';

//admin users
import { UsersPage } from '../pages/users/users';
import { UsersDetailPage } from '../pages/users/detail/detail';

// services
import { ApiService } from '../services/api.service';
import { FormService } from '../services/form.service';
import { DataService } from '../services/data.service';
import { UserDataService } from '../services/data.users.service';
import { MemberDataService } from '../services/data.members.service';
import { SchoolDataService } from '../services/data.schools.service';
import { TeacherDataService } from '../services/data.teachers.service';
import { EmailTplDataService } from '../services/data.emailtpls.service';

import { SharedDataService } from '../services/data.shared.service';

import { HelperService } from '../services/helper.service';

// widgets
import { MyDatePickerModule } from 'mydatepicker';

import { NmHeader } from '../widgets/header/header';
import { NmSidebar } from '../widgets/sidebar/sidebar';
import { NmBreadcrumbs } from '../widgets/breadcrumbs/breadcrumbs';
import { NmPageHeader } from '../widgets/page-header/page-header';
import { NmDatatable } from '../widgets/datatable/datatable.component';
import { NmWideget, NmWidgetHeader, NmWidgetBody, NmWidgetTools } from '../widgets/widget/widget';
import { NmFormGroup } from '../widgets/form-group/form-group';
import { NmInput } from '../widgets/input/input';
import { NmMaskedInput } from '../widgets/masked-input/masked-input';
import { NmSelect } from '../widgets/select/select';
import { NmReactiveSelect, NmReactiveOption } from '../widgets/reactive-select/reactive-select';
import { NmSwitch } from '../widgets/switch/switch';
import { NmCheckbox } from '../widgets/checkbox/checkbox';
import { NmWizard, NmWizardStep } from '../widgets/wizard/wizard';
import { NmTab, NmTabs } from '../widgets/tab/tab';
import { NmFormSubmitButtons } from '../widgets/form-submit-buttons/form-submit-buttons';
import { NmLoading } from '../widgets/loading/loading';
import { NmFooter } from '../widgets/footer/footer';
import { NmScrollUp } from '../widgets/scroll-up/scroll-up';
import { NmRadio } from '../widgets/radio/radio';
import { NmTextarea } from '../widgets/textarea/textarea';
import { NmDropdownButton } from '../widgets/dropdown-button/dropdown-button';

// classes
import { NmDetailPageClass } from '../shared/nm-detail-page-class';

@NgModule({
  declarations: [
    AppComponent,
    // pages
    LoginPage,
    DashBoardPage,
    //members
    MembersSearchPage,
    MembersPendingPage,

    MembersDetailPage,
    MembersDetailBasicInformation,
    MembersDetailMembershipInformation,
    MembersDetailDemographicInformation,
    MemberDetailTabView,
    MembersReportPage,
    MembersBatchUploadPage,
    MembersSendpwdPage,

    //schools
    SchoolsSearchPage,
    SchoolsReportPage,
    SchoolsDetailPage,
    SchoolsDetailBasicInformation,
    SchoolsDetailTabView,

    //schools
    TeachersSearchPage,
    TeachersReportPage,
    TeachersDetailPage,
    TeachersDetailBasicInformation,

    //email tpls
    EmailTplsListPage,
    EmailTplsDetailPage,
    EmailTplsDetailBasicInformation,

    //users
    UsersPage,
    UsersDetailPage,


    // widgets
    NmHeader,
    NmSidebar,
    NmBreadcrumbs,
    NmPageHeader,
    NmDatatable,
    NmWideget,
    NmWidgetHeader,
    NmWidgetBody,
    NmWidgetTools,
    NmFormGroup,
    NmInput,
    NmMaskedInput,
    NmSelect,
    NmReactiveSelect,
    NmReactiveOption,
    NmSwitch,
    NmCheckbox,
    NmWizard,
    NmWizardStep,
    NmTab,
    NmTabs,
    NmFormSubmitButtons,
    NmLoading,
    NmFooter,
    NmScrollUp,
    NmRadio,
    NmTextarea,
    NmDropdownButton,

    // classes
    NmDetailPageClass

  ],
  imports: [
    AppRoutesModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    MyDatePickerModule,
    CKEditorModule
  ],
  providers: [
    // services
    ApiService,
    FormService,
    HelperService,
    DataService,
    UserDataService,
    MemberDataService,
    SchoolDataService,
    TeacherDataService,
    EmailTplDataService,

    SharedDataService,


    // guards
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts